export default {
    state: {
        pendingRequests: []
    },
    mutations: {
        requestStarts(state, request) {
            state.pendingRequests.push(request);
        },
        requestEnds(state, request) {
            let index = state.pendingRequests.indexOf(request);
            if (index > -1) {
                state.pendingRequests.splice(index, 1);
            }
        }
    },
    getters: {
        pendingRequestsCount: state => state.pendingRequests.length
    }
}